import React from 'react'

const InvoiceCard = ({amount, invoice, date}) => {
  return (
    <div className="text-center bg-light radius-20 mt-3 p-4">
        <h1 className='text-medium text-orange'>${amount}</h1>
        <h5 className='text-semibold mb-1'>{invoice}</h5>
        <p className='text-medium mb-2 text-success'>Due Date: {date}</p>
    </div>
  )
}

export default InvoiceCard;